<template>
  <div>
    <SalesRegisterTableCard :isEmpty="! tableItems.length">
      <table class="table register-table">
        <thead>
        <tr>
          <th>Date</th>
          <th>Invoice No</th>
          <th>Invoice Type</th>
          <th>Order Type</th>
          <th>Client Name</th>
          <th>Business Unit</th>
          <th>Sales Person</th>
          <th class="num">Invoice Amount</th>
          <th class="num">VAT Amount</th>
          <th class="num">Total Amount</th>
          <th class="num">Bill Sett. Discount</th>
          <th class="num">Adjusted Amount</th>
          <th class="num">Net Collection</th>
          <th class="num">Due Amount</th>
          <th class="text-center">Status</th>
          <th class="text-center">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td class="text-nowrap">{{ item.date }}</td>
          <td class="text-nowrap">
            <a href="javascript:void(0)" class="invoice-link" @click.stop="onClickAddNewButton(item)">{{ item.bill_number }}</a>
          </td>
          <td>{{ item.invoice_type }}</td>
          <td>{{ item.sales_order_master ? item.sales_order_master.sale_type_title : '' }}</td>
          <td class="name-cell">{{ item.contact_name }}</td>
          <td>{{ item.business_name }}</td>
          <td>{{ item.sr_name }}</td>
          <td class="num">{{ item.subtotal_amount }}</td>
          <td class="num">{{ item.vat_amount }}</td>
          <td class="num">{{ item.total_amount_with_points }}</td>
          <td class="num">{{ item.discount }}</td>
          <td class="num">{{ getAdjustedAmount(item) }}</td>
          <td class="num">{{ item.paid_amount }}</td>
          <td class="num fw-bold">{{ getTotalDue(item) }}</td>
          <td class="text-center">
            <span class="status-badge" :class="item.payment_status === 'DUE' ? 'is-due' : 'is-paid'">{{ item.payment_status }}</span>
          </td>
          <td class="text-center">
            <div class="d-inline-flex gap-1">
              <button v-if="item.payment_status === 'DUE'" class="row-icon-btn" title="Money Receipt" @click="onClickAddNewButton(item)">
                <i class="fas fa-plus"></i>
              </button>
              <button v-if="item.receipt_masters && item.receipt_masters.length" class="row-icon-btn" title="Print Receipt" @click="goToPrintMoneyReceipt(item)">
                <i class="fas fa-print"></i>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
        <tfoot v-if="tableItems.length && currentPage === lastPage">
        <tr>
          <td colspan="7" class="register-total-label">Total</td>
          <td class="num">{{ totalValue && totalValue.total_subtotal_amount }}</td>
          <td class="num">{{ totalValue && totalValue.total_vat_amount }}</td>
          <td class="num">{{ totalValue && totalValue.total_amount_with_points }}</td>
          <td class="num">{{ totalValue && totalValue.total_discount_amount }}</td>
          <td class="num">{{ totalValue && getTotalAdjustedAmount(tableItems) }}</td>
          <td class="num">{{ totalValue && totalValue.total_paid_amount }}</td>
          <td class="num">{{ totalValue && totalValue.total_due_amount }}</td>
          <td></td>
          <td></td>
        </tr>
        </tfoot>
      </table>
    </SalesRegisterTableCard>
    <MoneyReceiptPrint
        v-if="store.state.isModalOpenTwo"
        :moneyReceiptData="moneyReceiptData"
        :companyInfo="companyInfo"
    />
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import {ref, onMounted} from "vue";
import {useStore} from "vuex";
import MoneyReceiptPrint from '@/components/molecule/company/inventory/pending-money-receipt/MoneyReceiptPrint';
import SalesRegisterTableCard from '@/components/molecule/company/inventory/product-sales-register/SalesRegisterTableCard.vue';
import handleCompany from "@/services/modules/company";

const props = defineProps({
  tableItems: {
    type: Array,
  },
  currentPage: Number,
  lastPage: Number,
  totalValue: Object,
})
const route = useRoute()
const router = useRouter()
const store = useStore()
const {fetchCompanyInfo} = handleCompany();

const companyInfo = ref({});
const moneyReceiptData = ref([]);

onMounted(() => {
  fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo.value = res.data;
  }).catch((error) => {
    console.log(error);
  });
});

const onClickAddNewButton = (item) =>  {
  let query = {
   saleMasterId:item.id,
   contactId:item.contact_profile_id,
   type:'pending-money-receipt',
   start:route.query.start,
   end:route.query.end,
   page:route.query.page,
  }
  return router.push({name: 'sales-invoice-receipt', params: route.params, query: query})
}

const getTotalDue = (item) => {
  return parseFloat(item.total_amount) - (parseFloat(item.paid_amount) + parseFloat(item.adjusted_amount))
}

const getAdjustedAmount = (item) => {
  const pointsRedeemed = item.points_redeemed ? parseFloat(item.points_redeemed) : 0
  return parseFloat(item.adjusted_amount) - parseFloat(item.discount) + pointsRedeemed
}

const getTotalAdjustedAmount = (items) => {
  return items.reduce((total, saleMaster) => total + getAdjustedAmount(saleMaster), 0);
}

const goToPrintMoneyReceipt = (item) => {
  moneyReceiptData.value = item.receipt_masters && item.receipt_masters.length ? item.receipt_masters : [];
  store.state.isModalOpenTwo = true;
}

</script>

<style scoped>
.register-table tbody td {
  padding: 10px 14px !important;
}
.register-table tfoot td {
  padding: 12px 14px !important;
}
.invoice-link {
  font-weight: 600;
  color: #7367f0;
}
.invoice-link:hover {
  text-decoration: underline;
}
.name-cell {
  min-width: 140px;
}
.status-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .03em;
}
.status-badge.is-due {
  background: #fffaeb;
  color: #b54708;
}
.status-badge.is-paid {
  background: #ecfdf3;
  color: #027a48;
}
.row-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  background: #fff;
  color: #7367f0;
  font-size: 12px;
  cursor: pointer;
  transition: all .15s ease;
}
.row-icon-btn:hover {
  border-color: #7367f0;
  background: #f4f3ff;
}
</style>